import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconCategorySvg } from "./IconCategorySvg.mjs";
const IconCategory = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconCategorySvg, ...svgProps }) });
export {
  IconCategory
};
